/**
 * Represents the appearance of the icon.
 */
export enum IconAppearance {
    REGULAR = 'regular',
    BOLD = 'bold',
    FILL = 'fill',
}

export const ICON_CLASSES: Record<IconAppearance, string> = {
    [IconAppearance.REGULAR]: 'ph',
    [IconAppearance.BOLD]: 'ph-bold',
    [IconAppearance.FILL]: 'ph-fill'
};
